import { cn } from "@/lib/utils";

interface CitationPillProps {
  n: number;
  missing?: boolean;
  onClick?: () => void;
}

export const CitationPill: React.FC<CitationPillProps> = ({
  n,
  missing,
  onClick,
}) => (
  <span
    className={cn(
      "inline-block min-w-[20px] px-1.5 rounded-full text-[11px] font-semibold text-center text-white align-[1px] mx-0.5",
      missing
        ? "bg-neutral-400 cursor-help"
        : "bg-blue-600 cursor-pointer hover:bg-blue-700",
    )}
    title={missing ? "해당 인용을 찾을 수 없음" : undefined}
    onClick={missing ? undefined : onClick}
  >
    {n}
  </span>
);
